import {charsheetAPI} from '../globals.js';
import axios from 'axios';
import Cookies from "js-cookie";

import createUser from './createUser.js'
import getAccessToken from './getAccessToken.js';

const handleCharChange = async ( result, userData, setUserData, currentChar, setCurrentChar, currentCampaign ) => {

    // check for deleted character
    if ( result.message === 'character deleted' ) {
        // remove the character from the userData.campaigns[currentCampaign].characters array
        const newUserData = { ...userData };
        // remove the character from the array
        newUserData.dynamoData.campaigns[currentCampaign].characters = newUserData.dynamoData.campaigns[currentCampaign].characters.filter(char => char !== currentChar);
        setUserData(newUserData);
        // push results to createUser
        try {
            const newUser = await createUser(userData.uniqueUser, userData.username, newUserData.dynamoData.campaigns);
            console.log('User saved:', newUser);
        } catch (error) {  
            console.error('Error saving userData:', error); 
        }

        console.log('Character deleted from userData:', newUserData);
        alert ('Character deleted');
        return 'character removed from userData';
    }
    

    console.log('save to Campaign:', currentCampaign)
    console.log('SAVE_CHAR result:', result);

    if ( result.newCharData.name !== currentChar ) {
        setCurrentChar(result.newCharData.name);
    }

    if ((await result).isNew) {

        /* const decision = window.confirm("This character is new. Do you want to add to userData?");
        if (!decision) {
            console.log('Character will not be added to userData');
            return;
        }
        */
        
        // if the character is new, update userData.campaigns[currentCampaign].characters
        const newUserData = { ...userData };
        
        // check if the campaign exists in userData
        console.log('userData', userData)
        if (!newUserData.dynamoData.campaigns[currentCampaign]) {
        newUserData.dynamoData.campaigns[currentCampaign] = { characters: [] };
        }

        // add user to campaign data
        newUserData.dynamoData.campaigns[currentCampaign].characters.push((await result).newCharData.name);
        setUserData(newUserData);

        // set character as current Character
        setCurrentChar((await result).newCharData.name)

        // createUser = async ( userName, userAlias='', campaigns={} )
        try {
        const newUser = await createUser(userData.uniqueUser, userData.username, newUserData.dynamoData.campaigns);
        console.log('User saved:', newUser);
        } catch (error) {
        console.error('Error saving user:', error); 
        }
        
        console.log('New character added to userData:', newUserData);
    }

    
}

export default handleCharChange;